import React from "react";
import { connect } from "react-redux";
// import Footer1 from "../Utils/GenericUI/Footer1";
// import MenuIcon from "@material-ui/icons/Menu";
// import history from "../Utils/History";
// import PlanCard from "./PlanCard";
// SONARimport { setFormData } from "../Redux/Actions/webAppActions";

const SupplementDetailsTable = ({ displayDetailList, type, ...props }) => {
  return (
    <React.Fragment>
      <h5 class={"pres-drug"}>{type}</h5>
      {displayDetailList.map((displayDetail, index) => {
        return (
          <div>
            <div class="display-flex fit-content">
              <h6 class={"container-header"}>{displayDetail.category}</h6>
              {displayDetail.description.map((detail, idx) => {
                // Directly rendering content instead of using dangerouslySetInnerHTML
                return (
                  <div key={idx} class="container-planDetail fit-content">{detail}</div>
                );
              })}
            </div>
            <hr />
          </div>
        );
      })}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    
  };
};
const mapDispatchToProps = {
  //   setFormData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SupplementDetailsTable);
